<template>
  <section>
    <QrcodeDialog ref="qrcodeDialog" />
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
          <!-- <el-table-column type="selection" width="55" /> -->
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <el-table-column
            v-for="(item, index, key) in tableData.title"
            :key="key"
            :prop="item.prop"
            :label="item.label"
            :sortable="item.sortable"
            :filters="item.filters"
            :filter-method="item.filterHandler"
            :min-width="item.minW"
            :width="item.w"
          />
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </section>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import {
  customerArchivesList,
} from 'api/archives';
import QrcodeDialog from 'components/qrcodeDialog';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    QrcodeDialog,
  },
  data () {
    return {
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          {
            prop: 'customerCode',
            label: '省份',
          },
          {
            prop: 'companyName',
            label: '油价（元/升）',
          },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: customerArchivesList,
  },
};
</script>

<style lang="scss" scoped>
.control {
  span {
    margin-right: 16px;
  }
}
</style>
